import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import FormField from '../form-field';
import {generatePath} from '../../utilities/RedirectUtils';
import {sendJacadaRequest} from '../../api';
import ButtonGroup from "../button-group";
import {
  getPepSession,
  isPayPerUseSelector
} from "../../selector";
import {
  pepSession,
  updateAdditionalFields,
  updateIsPrimaryLookup
} from '../../action';
import LookUpFormHeader from './Components/LookUpFormHeader';
import Form from '../form';
import { Button } from 'mesh-component-library';
import {useLocale} from "../../contexts/LocaleContext";
import {TRANSLATION_CONSTANTS} from '../../app-consts/translations';
import CONSTANTS from "../../app-consts/appConstants";
import { getOmniStreamlinedFlag } from '../../features/FeatureFlags';

const FirstNameLastNameCustomerTypeLookup = ({
  partnerDetails,
  history,
  showModal,
  closeModal,
  dispatchCommonBenefitsLookup
}) => {
  const {displayCode, appId, promoCode} = partnerDetails;
  const [firstName, setFirstName] = useState({value:''});
  const [lastName, setLastName] = useState({value:''});
  const [isMilitaryBase, setIsMilitaryBase] = useState(false);
  const [customerType, setcustomerType] = useState("customer");
  const spaceOrLetter = new RegExp("^[a-zA-Z ]+$");
  const pepSessionState = useSelector(getPepSession);
  const omniStreamlined = useSelector(getOmniStreamlinedFlag)
  const dispatch = useDispatch();
  const getTranslatedText = useLocale()
  const isPayPerUse = useSelector(isPayPerUseSelector)

  useEffect(() => {
    if(pepSessionState.loading === false) {
      if(pepSessionState.error ===true) {
        localStorage.setItem('rescueCancel','NO');
        history.push(generatePath('sitedown'));
      } else if(pepSessionState.success === true && pepSessionState.session !== "") {
        localStorage.setItem('rescueCancel','NO');
        if(isPayPerUse) {
          history.push(generatePath('home'));
        }
      }
    }
  }, [pepSessionState.loading]);

  const continueClick = () => {

    localStorage.setItem('firstName', firstName.value);
    localStorage.setItem('lastName', lastName.value);
    localStorage.setItem('customerType', customerType);

    dispatch(updateIsPrimaryLookup(false))

    let user = {
      details: {
        firstName:  firstName.value,
        lastName: lastName.value,
      },
      phoneLookup: false,
      appId,
      lookupType: CONSTANTS.FIRST_NAME_LAST_NAME_COMPANY,
      promoCode: promoCode,
      guestFlow: true,
      customerType: customerType
    };

    if(!omniStreamlined) {
      user.memberId = "";
      user.details.zip = null;
      user.details.isMilitaryBase = isMilitaryBase;

      let eventsData = [];
      eventsData.push(
        {
          'name': 'firstname',
          'value': user.details.firstName
        },
        {
          'name': 'lastname',
          'value': user.details.lastName
        },
        {
          'name':'disblmnt_prmotn_cd',
          'value':user.details.disblmnt_prmotn_cd
        }
      );

      let jacadaRequestData = {
        'externalSystemId': localStorage.getItem('conversationId'),
        'events': eventsData
      };

      sendJacadaRequest(jacadaRequestData);
      dispatch(pepSession(user));
    } else {
      dispatchCommonBenefitsLookup(user)
    }
  };

  const firstNameOnChange = e => {
    let inputString = e.target.value;
    if (!spaceOrLetter.test(inputString)) {
      setFirstName({ value: inputString.slice(0, inputString.length - 1) });
    } else {
      setFirstName({ value: inputString });
    }
  };

  const lastNameOnChange = e => {
    let inputString = e.target.value;
    if (!spaceOrLetter.test(inputString)) {
      setLastName({ value: inputString.slice(0, inputString.length - 1) });
    } else {
      setLastName({ value: inputString });
    }
  };

  const isInvalid = () => {
    const firstNameIsValid = firstName.value.trim().length;
    const lastNameIsValid = lastName.value.trim().length;

    return !(firstNameIsValid && lastNameIsValid);
  };

  const militaryBasePickup = () => {
    setIsMilitaryBase(true);
    setcustomerType("militaryBase")
  };

  const noMilitaryBasePickup = () => {
    setIsMilitaryBase(false);
    setcustomerType("customer")
  };

  const onSubmit = () => {
    const content = <div>
      <p><span>{getTranslatedText(TRANSLATION_CONSTANTS.FIRST_NAME)}:</span> {firstName.value}</p>
      <p><span>{getTranslatedText(TRANSLATION_CONSTANTS.LAST_NAME)}:</span> {lastName.value}</p>
    </div>
    const options = {
      titleHtml: content,
      yesNoSelected,
    }

    showModal(options);
  };

  const yesNoSelected = async ({target: {value}}) => {
    closeModal()
    if (value === "yes") {
      continueClick()
    }
  }

  return (
    <React.Fragment>
      <LookUpFormHeader titleText={getTranslatedText(TRANSLATION_CONSTANTS.INFO_TO_DISPATCH)} id={"we-need-some-info-to-find-your-benefits-pep"}/>
      <Form id="pep-lookup" className="c-container-lookup__form u-align-left">
        <FormField
          errorText={getTranslatedText(TRANSLATION_CONSTANTS.PLEASE_ENTER_YOUR_FIRST_NAME)}
          label={getTranslatedText(TRANSLATION_CONSTANTS.FIRST_NAME)}
          id="firstname"
          className="firstname"
          minLength={3}
          name="firstname"
          x-autocompletetype="given-name"
          autoComplete="given-name"
          value={firstName.value}
          onChange={firstNameOnChange}
          onBlur={()=>setFirstName({value: firstName.value.trim()})}
          tabIndex="0"
          required />

        <FormField
          errorText={getTranslatedText(TRANSLATION_CONSTANTS.PLEASE_ENTER_YOUR_LAST_NAME)}
          label={getTranslatedText(TRANSLATION_CONSTANTS.LAST_NAME)}
          id="lastname"
          className="lastname u-vr-3-top"
          minLength={3}
          name="lastname"
          x-autocompletetype="family-name"
          autoComplete="family-name"
          value={lastName.value}
          onChange={lastNameOnChange}
          onBlur={()=>setLastName({value: lastName.value.trim()})}
          tabIndex="0"
          required />

        <ButtonGroup
          data-dd-privacy="allow"
          label={getTranslatedText(TRANSLATION_CONSTANTS.PEP_BOYS_MILITARY_BASE_QUESTION, displayCode)}
          type="radio"
          name="commercial-purposes"
          required
          onChange={() => {}}
          options={[
            {
              text: getTranslatedText(TRANSLATION_CONSTANTS.YES),
              value: 'yes',
              checked: isMilitaryBase === true,
              onClick: militaryBasePickup,
              onKeyDown: militaryBasePickup,
            },
            {
              text: getTranslatedText(TRANSLATION_CONSTANTS.NO),
              value: 'no',
              onClick: noMilitaryBasePickup,
              onKeyDown: noMilitaryBasePickup,
              checked: isMilitaryBase === false,
            }
          ]} />
        <br/>
        <Button
          size='lg'
          hasUpgrade
          id="lookup-continue"
          data-testid="continue-company-name-form"
          disabled={isInvalid()}
          onClick={onSubmit}
          utils={{
            fullWidth: true
          }}>
          {getTranslatedText(TRANSLATION_CONSTANTS.CONTINUE)}
        </Button>
      </Form>
    </React.Fragment>
  );
};

export default FirstNameLastNameCustomerTypeLookup;
